import { render, staticRenderFns } from "./contatto.vue?vue&type=template&id=2f011f5a"
import script from "./contatto.vue?vue&type=script&lang=js"
export * from "./contatto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports